<template>
  <div>
    <page-header>
      <div v-if="sorting">
        <div>
          <div></div>
          <el-button size="mini" type="primary" @click="finishSort">完成</el-button>
          <el-button size="mini" @click="cancelSort">取消</el-button>
        </div>
      </div>
      <div v-if="!sorting">
        <el-button type="primary" @click="addHotSearch">新增热搜</el-button>
        <el-button type="success" @click="startSort">编辑排序</el-button>
        <el-button type="info" @click="showSearchLogs">搜索记录</el-button>
      </div>
      <div>
      </div>
    </page-header>
    <el-table v-if="!sorting" :data="list" border>
      <el-table-column label="内容" prop="content"/>
      <el-table-column label="类型">
        <template #default="scope">
          <span v-if="scope.row.type === 'PRODUCT'">商品</span>
          <span v-if="scope.row.type === 'SERVICE'">服务</span>
          <span v-if="scope.row.type === 'MERCHANT'">商户</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="text" @click="list.splice(scope.$index,1)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="sorting">
      <el-table :data="sortingList" border ref="table">
        <el-table-column label="内容" prop="content"/>
        <el-table-column label="类型">
          <template #default="scope">
            <span v-if="scope.row.type === 'PRODUCT'">商品</span>
            <span v-if="scope.row.type === 'SERVICE'">服务</span>
            <span v-if="scope.row.type === 'MERCHANT'">商户</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button disabled type="text">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <page-header style="margin-top: 20px">
      <el-button type="primary" @click="saveHotSearches">保存</el-button>
    </page-header>


    <el-dialog :visible.sync="hotSearchDialog.visible" append-to-body :close-on-click-modal="false" top="20px"
               width="600px">
      <el-form label-width="80px">
        <el-form-item label="内容">
          <el-input v-model="hotSearchDialog.form.content"/>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="hotSearchDialog.form.type">
            <el-option value="PRODUCT" label="商品"/>
            <el-option value="SERVICE" label="服务"/>
            <el-option value="MERCHANT" label="商户"/>
          </el-select>
        </el-form-item>
      </el-form>
      <button-line>
        <el-button type="primary" @click="confirmAddHotSearch">确定</el-button>
        <el-button @click="hotSearchDialog.visible = false;">取消</el-button>
      </button-line>
    </el-dialog>

    <el-dialog :visible.sync="searchLogDialog.visible" append-to-body :close-on-click-modal="false" top="20px"
               width="600px">
      <page-header>
        <el-date-picker v-model="searchLogDialog.filter.date" value-format="yyyy-MM-dd"/>
        <el-button type="primary" style="margin-left: 12px" circle icon="el-icon-search" @click="getSearchLogs(1)"/>
      </page-header>
      <table-union-pager :data="searchLogDialog.tableData">
        <el-table-column prop="content" label="内容"/>
        <el-table-column label="类型">
          <template #default="scope">
            <span v-if="scope.row.type === 'PRODUCT'">商品</span>
            <span v-if="scope.row.type === 'SERVICE'">服务</span>
            <span v-if="scope.row.type === 'MERCHANT'">商户</span>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="搜索次数"/>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button @click="selectSearchLog(scope.row)" type="primary">加入热搜</el-button>
          </template>
        </el-table-column>
      </table-union-pager>
      <button-line>
        <el-button @click="searchLogDialog.visible = false;">关闭</el-button>
      </button-line>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/utils/api";
import PageHeader from "@/components/PageHeader";
import ButtonLine from "@/components/ButtonLine";
import sortablejs from "sortablejs";
import dateformat from 'dateformat';
import TableUnionPager from "@/components/TableUnionPager";

export default {
  name: "HotSearches",
  components: {TableUnionPager, ButtonLine, PageHeader},
  data() {
    return {
      list: [],
      hotSearchDialog: {
        visible: false,
        form: {
          content: '',
          type: 'PRODUCT'
        }
      },
      sortingList: [],
      sorting: false,
      searchLogDialog: {
        visible: false,
        tableData: {
          list: [],
          totalCount: 0,
          page: 1,
          pageSize: 10
        },
        filter: {
          date: ''
        }
      }
    }
  },
  methods: {
    getHotSearchList() {
      api.hotSearch_getHotSearchList().then(res => {
        this.list = res.data.data;
      });
    },
    addHotSearch() {
      this.hotSearchDialog.form = {
        content: '',
        type: 'PRODUCT'
      }
      this.hotSearchDialog.visible = true;
    },
    confirmAddHotSearch() {
      this.list.push({
        content: this.hotSearchDialog.form.content,
        type: this.hotSearchDialog.form.type
      });
      this.hotSearchDialog.visible = false;
    },
    saveHotSearches() {
      let contents = [];
      let types = [];
      for (let hotSearch of this.list) {
        contents.push(hotSearch.content);
        types.push(hotSearch.type);
      }
      api.hotSearch_editHotSearches({
        contents: contents,
        types: types
      }).then(res => {
        if (res.data.code !== '000') {
          this.$message.error(res.data.message);
          return;
        }
        this.$message.success('保存成功');
      });
    },
    startSort() {
      this.sorting = true;
      this.$nextTick(() => {
        this.sortingList = Object.assign([], this.list);
        let table = this.$refs['table'].$el;
        table = table.getElementsByTagName('table').item(1);
        table.style.cursor = 'move';
        table.style.userSelect = 'none';
        document.body.ondrop = e => {
          e.preventDefault();
          e.stopPropagation();
        }
        let sortEnd = (e) => {
          let oldIndex = e.oldIndex;
          let newIndex = e.newIndex;
          if (oldIndex === newIndex) {
            return;
          }
          let start = Math.min(oldIndex, newIndex);
          let end = Math.max(oldIndex, newIndex);
          let list = this.sortingList;
          if (oldIndex < newIndex) {
            let temp = list[start];
            for (let i = start + 1; i <= end; i++) {
              list[i - 1] = list[i];
            }
            list[end] = temp;
          } else {
            let temp = list[end];
            for (let i = end - 1; i >= start; i--) {
              list[i + 1] = list[i];
            }
            list[start] = temp;
          }
        }
        sortablejs.create(table.getElementsByTagName('tbody').item(0), {
          onEnd: sortEnd
        });
        // document.createElement('div').style.cursor = 'move'
      });
    },
    cancelSort() {
      this.sorting = false;
    },
    finishSort() {
      this.list = this.sortingList;
      this.sorting = false;
    },
    showSearchLogs() {
      this.searchLogDialog.visible = true;
      this.searchLogDialog.filter.date = dateformat(new Date(), 'yyyy-mm-dd');
      this.getSearchLogs(1);
    },
    getSearchLogs(page) {
      this.searchLogDialog.tableData.page = page;
      api.hotSearch_getSearchLogs({
        page: page,
        pageSize: 10,
        date: this.searchLogDialog.filter.date
      }).then(res => {
        this.searchLogDialog.tableData.list = res.data.data.list;
        this.searchLogDialog.tableData.totalCount = res.data.data.totalCount;
      });
    },
    selectSearchLog(searchLog) {
      console.log(searchLog.content);
      this.list.push({
        content: searchLog.content,
        type: searchLog.type
      });
      this.searchLogDialog.visible = false;
    }
  },
  mounted() {
    this.getHotSearchList();
  }
}
</script>

<style scoped>

</style>
